export default defineNuxtRouteMiddleware(async (to) => {
  const { pagetype, additionalBody, destination } = useConfdata()

  if (pagetype !== 'search') return

  const { isRedesign } = useRedesignFeature()

  if (isRedesign.value) return

  const params = useParams()
  const { searchfilterconfs } = additionalBody as SearchPageBody
  const searchQuery = createSearchQuery(
    to.path,
    params,
    destination,
    searchfilterconfs,
  )

  useSearch().setFilter(searchQuery, { reset: true })
})
